import React from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen grain-bg flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white border border-[#E5E1D8] rounded-2xl p-8 shadow-sm text-center" data-testid="payment-cancel-page">
        <div className="w-14 h-14 rounded-2xl bg-[#FBE9E4] text-[#A85540] flex items-center justify-center mx-auto"><XCircle size={28} /></div>
        <h2 className="mt-4 text-2xl font-semibold">{t("payment_cancelled")}</h2>
        <p className="text-sm text-[#5C6053] mt-1">{t("payment_cancelled_desc")}</p>
        <div className="mt-6 flex gap-2 justify-center">
          <button onClick={() => navigate("/pay")} data-testid="retry-pay-btn" className="brand-btn px-5 py-2.5 rounded-lg text-sm">{t("try_again")}</button>
          <button onClick={() => navigate("/app")} className="px-5 py-2.5 rounded-lg text-sm border border-[#E5E1D8]">{t("back")}</button>
        </div>
      </div>
    </div>
  );
}
